/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropTwitchVodResponse } from './DropTwitchVodResponse';
import {
    DropTwitchVodResponseFromJSON,
    DropTwitchVodResponseFromJSONTyped,
    DropTwitchVodResponseToJSON,
    DropTwitchVodResponseToJSONTyped,
} from './DropTwitchVodResponse';

/**
 * 
 * @export
 * @interface DropTwitchVodsResponse
 */
export interface DropTwitchVodsResponse {
    /**
     * 
     * @type {string}
     * @memberof DropTwitchVodsResponse
     */
    channelId: string | null;
    /**
     * 
     * @type {Array<DropTwitchVodResponse>}
     * @memberof DropTwitchVodsResponse
     */
    vods: Array<DropTwitchVodResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropTwitchVodsResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropTwitchVodsResponse interface.
 */
export function instanceOfDropTwitchVodsResponse(value: object): value is DropTwitchVodsResponse {
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('vods' in value) || value['vods'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropTwitchVodsResponseFromJSON(json: any): DropTwitchVodsResponse {
    return DropTwitchVodsResponseFromJSONTyped(json, false);
}

export function DropTwitchVodsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTwitchVodsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'channelId': json['channelId'],
        'vods': ((json['vods'] as Array<any>).map(DropTwitchVodResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropTwitchVodsResponseToJSON(json: any): DropTwitchVodsResponse {
    return DropTwitchVodsResponseToJSONTyped(json, false);
}

export function DropTwitchVodsResponseToJSONTyped(value?: DropTwitchVodsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channelId': value['channelId'],
        'vods': ((value['vods'] as Array<any>).map(DropTwitchVodResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

